import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "add-review" }
const _hoisted_2 = { class: "add-review__caption" }
const _hoisted_3 = { class: "add-review__product-info" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "add-review__variant-image-overlay" }, null, -1)
const _hoisted_5 = { class: "add-review__details" }
const _hoisted_6 = { class: "add-review__brand" }
const _hoisted_7 = { class: "add-review__product-name" }
const _hoisted_8 = { class: "add-review__article-number" }

import { ref, computed, onMounted } from 'vue';

import useLitium from '@/composables/useLitium';
import useWebsiteTexts from '@/composables/useWebsiteTexts';
import { getReviewContext } from '@/composables/useReview';

import AddReviewForm from '@/components/Reviews/AddReviewForm.vue';
import ImageWithFallback from '@/components/ImageWithFallback.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddReview',
  setup(__props) {

const { productData, selectedVariant } = getReviewContext();
const { websiteText } = useWebsiteTexts();
const { toLitiumMediaUrl } = useLitium();

const isMounted = ref(false);

const url = computed(() => {
  return selectedVariant.value?.url;
});

const productBrand = computed(() => {
  return selectedVariant.value?.brandName;
});

const variantName = computed(() => {
  return selectedVariant.value?.variantName;
});

const articleNumber = computed(() => {
  return selectedVariant.value?.id;
});

const firstVariantImage = computed(() => {
  const image =
    selectedVariant.value?.images?.[0]
    || productData.value?.images?.[0];
  return toLitiumMediaUrl(image?.id, { maxWidth: 400 });
});

onMounted(() => {
  isMounted.value = true;
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(websiteText)('reviews__my_review_caption').value ||
        'reviews__my_review_caption'), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_router_link, {
        to: _unref(url),
        class: "add-review__thumbnail-container"
      }, {
        default: _withCtx(() => [
          _hoisted_4,
          (isMounted.value)
            ? (_openBlock(), _createBlock(ImageWithFallback, {
                key: 0,
                image: _unref(firstVariantImage),
                alt: _unref(variantName),
                loading: "lazy",
                class: "add-review__variant-image"
              }, null, 8, ["image", "alt"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["to"]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(productBrand)), 1),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(variantName)), 1),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(articleNumber)), 1)
        ])
      ]),
      _createVNode(AddReviewForm)
    ])
  ]))
}
}

})